<template>
  <div>
    <b-modal
      :id="id"
      :hide-footer="isHideFooter"
      size="xl"
      @hidden="isConfirm = false"
      title="預覽"
      title-class="custom-modal-title"
      header-class="custom-modal-header"
      dialog-class="custom-modal-dialog"
      content-class="custom-modal-content"
      footer-class="custom-modal-footer"
      body-class="custom-modal-body"
    >
    <div class="preview-container">
      <div class="preview-app">
        <h2>禮品詳情</h2>
        <div class="preview-app__drag-scroll" v-dragscroll.y="true">
          <MySwiper :slides-per-view="1">
            <MySwiperSlide>
              <img :src="item.covers.ulapp | imagePath('couponCover')" style="width: 100%;" />
            </MySwiperSlide>
            <MySwiperSlide v-for="image in item.images" :key="image">
              <img :src="image | imagePath('couponImages')" style="width: 100%;" />
            </MySwiperSlide>
          </MySwiper>
          <section class="preview-app__content">
            <div class="preview-app__merchant">
              {{ item.merchant.name }}
            </div>
            <div class="preview-app__coupon-name">
              {{ item.reward.name1 }}
            </div>
            <div class="preview-app__detail">
              <h3>詳情</h3>
              <div v-html="item.reward.desc"></div>
            </div>
            <h3 class="mb-3">備註:</h3>
            <div class="preview-app__expire">
              <h4>優惠使用期限</h4>
              <div>{{ item.couponMeta.expire }}</div>
            </div>
            <div class="preview-app__tnc">
              <h3>條款及細則</h3>
              <div v-html="item.reward.tnc"></div>
              <hr />
              <TNC></TNC>
            </div>
          </section>
          <div class="preview-app__bottom-tab">
            <img src="../../assets/img/preview-app-bottomtab.png" alt="Preview app bottomtab" />
          </div>
        </div>
      </div>
      <div class="preview-detail">
        <section>
          <h2>基本資料</h2>
          <div class="preview-detail__field">
            <h4>商戶/商店名稱</h4>
            <div>{{ item.merchant.name }}</div>
          </div>
          <div class="preview-detail__field">
            <h4>優惠名稱</h4>
            <div>{{ item.reward.name1 }}</div>
          </div>
          <div class="preview-detail__field">
            <h4>封面圖片</h4>
            <img v-if="item.covers.ulapp" :src="item.covers.ulapp | imagePath('couponCover')" />
          </div>
          <div class="preview-detail__field">
            <h4>相關圖片</h4>
            <img
              v-for="image in item.images"
              :src="image | imagePath('couponImages')"
              :key="image"
            />
          </div>
          <div class="preview-detail__field">
            <h4>折扣標籤</h4>
            <div>{{ item.reward.tagOnCover }}</div>
          </div>
          <div class="preview-detail__field">
            <h4>優惠使用期限</h4>
            <div>由 {{ item.couponMeta.startDate }}</div>
            <div>至 {{ item.couponMeta.expire }}</div>
          </div>
          <div class="preview-detail__field">
            <h4>網店連結</h4>
            <div v-if="item.reward.relatedLinkUrl">
              {{ item.reward.relatedLinkUrl }}
            </div>
          </div>
          <div class="preview-detail__field">
            <h4>優惠描述</h4>
            <div v-html="item.reward.desc"></div>
          </div>
          <div class="preview-detail__field">
            <h4>適用分店地址/ 網址</h4>
            <div v-html="item.reward.applicableAddressOrWebsite"></div>
          </div>
          <div class="preview-detail__field">
            <h4>每人可換領數量上限</h4>
            <div>{{ item.reward.maxRedeem ? item.reward.maxRedeem : '不限' }}</div>
          </div>
          <div class="preview-detail__field">
            <template v-if="item.reward.originalPrice || item.reward.price">
              <h4>售價</h4>
              <div>$HKD {{ price }}</div>
            </template>
            <template v-else>
              <h4>所需 U Fun</h4>
              <div>{{ item.reward.cost || '10~200 不等' }}</div>
            </template>
          </div>
          <div class="preview-detail__field">
            <h4>分類標籤</h4>
            <span v-for="tagId in sortedTags" :key="tagId">
              {{ getTagName(tagId, categoryTagOptions) }}
            </span>
          </div>
          <div class="preview-detail__field">
            <h4>推薦標簽</h4>
            <span v-for="tagId in sortedTags" :key="tagId">
              {{ getTagName(tagId, promoTagOptions) }}
            </span>
          </div>
          <div class="preview-detail__field" v-if="false">
            <h4>發佈平台</h4>
            <span v-for="availableOn in item.reward.availableOn" :key="availableOn">
              {{ availableOn }}
            </span>
          </div>
          <div class="preview-detail__field">
            <h4>條款及細則</h4>
            <div v-html="item.reward.tnc"></div>
          </div>
        </section>
        <section>
          <h2 class="preview-detail__section">優惠碼資料</h2>
          <div class="preview-detail__field">
            <h4>展示格式</h4>
            <div>
              {{ getCodeFormat(item.couponMeta.singleCode ? 'single_code' : 'multiple_code') }}
            </div>
          </div>
          <div class="preview-detail__field">
            <h4>優惠碼類型</h4>
            <div>{{ getCodeType(item.couponMeta.codeType) }}</div>
          </div>
        </section>
        <section v-if="item.reward.paymentType === 'HKD'">
          <div class="preview-detail__field">
            <h4>設定問題</h4>
            <DataTable style="width: 95%"
              v-show="item.questions"
              :fields="fields"
              :items="item.questions"
              :disableItemPerPage= true
              :borderless= true
            >
              <template v-slot:cell(questionType)="{ value }">
                <span>{{ value ===  "customized" ? "自定問題" : "預設問題" }}</span>
              </template>
              <template v-slot:cell(compulsory)="{ value }">
                <span>{{ value ===  true ? "是" : "否" }}</span>
              </template>
            </DataTable>
          </div>
        </section>
        <section>
          <h2 class="preview-detail__section">發佈設定</h2>
          <div class="preview-detail__field">
            <h4>發佈時間</h4>
            <div>由 {{ item.reward.publishOn }}</div>
            <div>至 {{ item.reward.publishDue }}</div>
          </div>
        </section>
      </div>
    </div>
      <template #modal-footer>
        <hr />
        <AGCCheckbox v-model="isConfirm" class="mb-3" rules="terms" required>
          <ConfirmTerm></ConfirmTerm>
        </AGCCheckbox>
        <b-button variant="secondary" @click="$bvModal.hide('coupon-preview-modal')">取消</b-button>
        <b-button variant="primary" @click="onSubmit">提交</b-button>
      </template>
    </b-modal>
    <CouponSubmitSuccessModal></CouponSubmitSuccessModal>
  </div>
</template>

<script>
import {
  BModal, BButton,
} from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { dragscroll } from 'vue-dragscroll';
import { getTagName } from '@/helpers/tag';
import formMixin from '@/mixins/form';
import { getCodeType, getCodeFormat } from '@/helpers/coupon';
import imagePath from '@/filters/image-path';
import TNC from '@/components/coupon/TNC.vue';
import CouponSubmitSuccessModal from './CouponSubmitSuccessModal.vue';
import MySwiper from '../my-swiper/MySwiper.vue';
import MySwiperSlide from '../my-swiper/MySwiperSlide.vue';
import AGCCheckbox from '../form/AGCCheckbox.vue';
import ConfirmTerm from '../form/ConfirmTerm.vue';
import DataTable from '@//components/DataTable.vue';

export default {
  mixins: [formMixin],
  name: 'CouponPreviewModal',
  components: {
    BModal,
    BButton,
    AGCCheckbox,
    ConfirmTerm,
    DataTable,
    CouponSubmitSuccessModal,
    MySwiper,
    MySwiperSlide,
    TNC,
  },
  props: {
    id: { type: String, required: true },
    item: { type: Object, required: true },
    categoryTagOptions: { type: Array },
    promoTagOptions: { type: Array },
  },
  data: () => ({
    isConfirm: false,
  }),
  computed: {
    ...mapGetters(['role']),
    isHideFooter() {
      if (this.role === 'merchant' || this.role === 'sale') {
        if (
          this.$route.name.toLowerCase().includes('add')
          || ['REJECTED', 'DRAFT'].includes(this.item.currentStatus?.status)
        ) {
          return false;
        }
      }
      return true;
    },
    sortedTags() {
      return [...this.item.tags].sort();
    },
    price() {
      let price = this.item.reward.originalPrice || 0;
      if (this.item.reward.price) {
        price = this.item.reward.price;
      }
      return new Intl.NumberFormat('zh-HK').format(parseFloat(price).toFixed(2));
    },
    fields() {
      return [
        { key: 'questionType', label: '問題類型' },
        { key: 'question', label: '問題' },
        {
          key: 'hints',
          label: '提示',
          sortable: false,
        },
        { key: 'compulsory', label: '買家必須填寫' },
      ];
    },
  },
  methods: {
    getCodeType,
    getCodeFormat,
    getTagName,
    onSubmit() {
      if (this.$route.name.toLowerCase().includes('add')) {
        this.$emit('submit-click');
      } else {
        this.$emit('resubmit-click');
      }
    },
  },
  directives: {
    dragscroll,
  },
  filters: {
    imagePath,
  },
};
</script>

<style lang="scss" scoped>
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

div {
  margin-bottom: 9px;
}

::v-deep {
  .close {
    font-size: 19px;
  }
  .custom-modal {
    &-dialog {
      margin: auto;
      margin-top: 6vh;
      margin-bottom: 6vh;

      @include respond(tab-landscape) {
        width: 90%;
      }

      @media (min-width: 576px) {
        max-width: 1024px;
        margin: 1.75rem auto;
      }
    }

    &-header {
      text-align: center;
      border: none;
      padding: 24px;
    }

    &-title {
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      color: #3a4047;
    }

    &-body {
      padding: 0px 24px 0px 24px;
    }

    &-content {
      font-size: 15px;
      border: none;
      border-radius: 6px;

      .form-group {
        margin-bottom: 0px;
      }

      .btn {
        padding: 10px 18px;
        width: 111px;

        &-primary {
          margin-left: 12px;
        }

        &-secondary {
          margin-left: 12px;
          background-color: #f9f9fa;
          border: 1px solid #dde1e5;
          color: #636d77;
          font-weight: 400;
        }
      }
    }

    &-footer {
      margin: 0px 24px 24px 24px;
      padding: 10px 0px 0px 0px;
    }
  }
}

.preview-container {
  display: flex;
  gap: 2.5%;
}

.preview-app {
  border: 1px solid #cccccc;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  height: 645px;
  width: 45%;

  @include respond(tab-landscape) {
    display: none;
  }

  &__merchant {
    color: #636d77;
  }

  &__content {
    padding: 0 15px 100px 15px;
    color: #333;
    line-height: 22px;
    font-size: 15px;
  }

  &__expire {
    h4 {
      font-size: 1rem;
    }

    div {
      font-size: 0.8rem;
    }
  }

  &__drag-scroll {
    overflow: hidden;
    overflow-wrap: break-word;
    height: 100%;

    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: -o-grab;
    cursor: grab;

    &:active {
      cursor: -webkit-grabbing;
      cursor: -moz-grabbing;
      cursor: -o-grabbing;
      cursor: grabbing;
    }
  }

  h2 {
    font-size: 16px;
    padding: 12px;
    text-align: center;
  }

  h3 {
    font-size: 14px;
    padding: 10px 0 10px 0;
  }

  &__bottom-tab {
    position: absolute;
    bottom: 0;
    margin: 0;

    img {
      width: 100%;
    }
  }

  &__coupon-name {
    border-bottom: 1px solid #ccc;
    font-size: 20px;
    color: #333;
    line-height: 40px;
  }
}

.preview-detail {
  width: 100%;
  height: 645px;
  overflow: scroll;
  overflow-x: hidden;
  color: #636d77;

  div {
    color: #3a4047;
  }

  h2 {
    font-size: 16px;
    color: #3a4047;
    margin-bottom: 16px;
  }

  img {
    width: 100px;
    height: auto;
    margin-right: 3px;
  }

  &__field {
    margin-bottom: 24px;
    font-size: 15px;
    font-weight: 400;

    @include respond(phone) {
      font-size: 14px;
    }

    h4 {
      color: #174169;
      font-size: 15px;
      margin-bottom: 4px;
      font-weight: 400;

      @include respond(phone) {
        font-size: 14px;
      }
    }
  }

  hr {
    margin-bottom: 24px;
  }
}
</style>
